module.exports = require("../utils/Expandable.vue");